import Vue from 'vue'

// v-dialogDrag: 弹窗拖拽
Vue.directive('dialogDrag', {
    bind(el, binding, vnode, oldVnode) {
        const dialogHeaderEl = el.querySelector('.el-dialog__header')
        const dragDom = el.querySelector('.el-dialog')
       dialogHeaderEl.style.cursor = 'move'
        //头部插入最大化最小化元素
        let nowHeight=400;//binding.value.h;
        let nowWidth=600;//binding.value.w;
        let nowMarginTop=50;
        let maxMin = document.createElement("button");

        maxMin.className += ' el-dialog__headerbtn el-dialog__minmax';
        maxMin.style.right = '40px';
        maxMin.style.color = '#a3abb8';
        maxMin.title = el.fullscreen ? '还原' : '最大化';
        maxMin.innerHTML = '<i class=' + (el.fullscreen ? '"el-icon-crop"' : '"el-icon-full-screen"') +' onMouseOver="this.style.color=\'#d3d3d3\'" onMouseOut="this.style.color=\'#a3abb8\'"></i>';
        dialogHeaderEl.insertBefore(maxMin, dialogHeaderEl.childNodes[1]);
        let bodyHeight = '800px';
        // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
        const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null)
        dialogHeaderEl.onmousedown = (e) => {
            // 鼠标按下，计算当前元素距离可视区的距离
            const disX = e.clientX - dialogHeaderEl.offsetLeft
            const disY = e.clientY - dialogHeaderEl.offsetTop

            // 获取到的值带px 正则匹配替换
            let styL, styT

            // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
            if (sty.left.includes('%')) {
                styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100)
                styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100)
            } else {
                styL = +sty.left.replace(/px/g, '')
                styT = +sty.top.replace(/px/g, '')
            }

            document.onmousemove = function(e) {
                // 通过事件委托，计算移动的距离
                const l = e.clientX - disX
                const t = e.clientY - disY
                if(e.clientY<0) return;
                // 移动当前元素
                dragDom.style.left = `${l + styL}px`
                dragDom.style.top = `${t + styT}px`

                // 将此时的位置传出去
                 binding.value={x:e.pageX,y:e.pageY}
            }

            document.onmouseup = function(e) {
                document.onmousemove = null
                document.onmouseup = null
            }
        }
        function setMaxMin() {
            if (el.fullscreen) {
                let i = maxMin.querySelector('.el-icon-crop');
                i.classList.remove('el-icon-crop');
                i.classList.add('el-icon-full-screen');
                maxMin.innerHTML = '<i class="el-icon-full-screen"></i>';
                maxMin.title = '最大化';
                dragDom.style.height = "auto";
                dragDom.style.width = nowWidth + 'px';
                dragDom.style.margin = '1vh auto 5px';
                dragDom.style.marginTop = nowMarginTop;
                el.fullscreen = false;

                dragDom.querySelector('.el-dialog__body').style.height = bodyHeight;
                dragDom.querySelector('.el-dialog__body').style['max-height'] = '80vh';
            } else {
                let i = maxMin.querySelector('.el-icon-full-screen');
                i.classList.remove('el-icon-full-screen');
                i.classList.add('el-icon-crop');
                maxMin.title = '还原';
                bodyHeight = dragDom.querySelector('.el-dialog__body').offsetHeight + 'px';
                i.h=bodyHeight;
                nowHeight = bodyHeight;// dragDom.clientHeight;
                nowWidth = dragDom.clientWidth;
                nowMarginTop = dragDom.style.marginTop;
                dragDom.style.left = 0;
                dragDom.style.top = 0;
                dragDom.style.height = "100%";
                dragDom.style.width = "100%";
                dragDom.style.margin = 0;
                dragDom.querySelector('.el-dialog__body').style.height = 'calc(100% - 40px)';
                dragDom.querySelector('.el-dialog__body').style['max-height'] = 'none';
                el.fullscreen = true;
                // dialogHeaderEl.style.cursor = 'initial';
                // dialogHeaderEl.onmousedown = null;
            }

            window.dispatchEvent(new Event("resize"));

        }
        maxMin.onclick = setMaxMin;
        //双击头部效果
        dialogHeaderEl.ondblclick = setMaxMin;
    }
})


